"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CbhError = void 0;
const non_empty_array_1 = require("./non-empty-array");
const ERROR_STATUS_CODES = [400, 401, 403, 404, 409, 429, 500];
class CbhError extends Error {
    issues;
    constructor(issues) {
        const is = (0, non_empty_array_1.toNonEmptyArray)(issues);
        const first = is[0];
        super(first?.message, { cause: first?.cause });
        // See https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#example
        Object.setPrototypeOf(this, new.target.prototype);
        this.issues = is;
        this.name = "CbhError";
    }
}
exports.CbhError = CbhError;
//# sourceMappingURL=cbh-error.js.map